import { render, staticRenderFns } from "./SignalIndicatorEMA.vue?vue&type=template&id=35d07569&scoped=true&"
import script from "./SignalIndicatorEMA.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalIndicatorEMA.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d07569",
  null
  
)

export default component.exports